import React from 'react';
import HeaderTags from '../../common/headerTags/HeaderTags';
import ProPageContainer from '../../components/pro/containers/ProPageContainer';
import { fetchProPageFaqsIfNeeded } from '../../components/pro/actions/ProPageAction';

const headerTags =
{
    title: 'Assinatura Pro - Conheça as vantagens e os planos', // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
    meta:
    {
        description: 'Conheça todas as vantagens e benéficos de assinatura PRO da Antena 1. Saiba como assinar e escolher o melhor plano pra você.',
        keywords: 'PRO, Assinatura Antena 1, Planos, Valores, Vantagens, Vantagens da Assinatura, Plano Mensal, Plano Anual, Promoções PRO, Notícias PRO, Streamings Exclusívos, Benefícios da Assinatura',
        'og:title': 'Assinatura Pro - Conheça as vantagens e os planos',
        'og:description': 'Conheça todas as vantagens e benéficos de assinatura PRO da Antena 1. Saiba como assinar e escolher o melhor plano pra você.',
        'og:image': 'https://a1media.antena1.com.br/image/share/seja-pro.png',
    },
};

const ProPage = () => (
    <div className="pageWrapper">
        <HeaderTags title={headerTags.title} meta={headerTags.meta} />
        <ProPageContainer />
    </div>
);

ProPage.fetchData = function fetchData(store) {
    return store.dispatch(fetchProPageFaqsIfNeeded());
};

export default ProPage;
